import { useCallback, useState } from 'react'
import { Alert, Button, Empty, Form, Input, Modal, Tag } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import type { useWorkflows } from '../hooks/useWorkflows'
import { Icon } from './Icon'

const ADD = <PlusOutlined aria-hidden />
const RULES = [{ required: true, whitespace: true, message: '请输入流程名称' }]
const FlowItem = ({ id, title, active, selected, select }: { id: string; title: string; active: boolean; selected: boolean; select: (id: string) => void }) => {
  const click = useCallback(() => select(id), [id, select])
  return <button type="button" role="option" aria-selected={selected} onClick={click}
    className={`instance-administration__flow-item${selected ? ' is-selected' : ''}`}>
    <Icon iconKey="branches" /><span>{title}</span>{active ? <Tag color="success">当前启用</Tag> : null}
  </button>
}

/** The only workflow selector lives in the left catalog. A click never publishes. */
export const WorkflowList = ({ model }: { model: ReturnType<typeof useWorkflows> }) => {
  const [open, setOpen] = useState(false)
  const [expanded, setExpanded] = useState(true)
  const toggle = useCallback(() => setExpanded((value) => !value), [])
  const [form] = Form.useForm<{ title: string }>()
  const add = useCallback(() => { form.resetFields(); setOpen(true) }, [form])
  const close = useCallback(() => setOpen(false), [])
  const create = useCallback(({ title }: { title: string }) => { model.create(title); close() }, [close, model])
  const submit = useCallback(() => form.submit(), [form])
  const initialize = useCallback(() => { void model.initialize().catch(() => undefined) }, [model])
  const reload = useCallback(() => { void model.reload().catch(() => undefined) }, [model])
  const retry = <Button size="small" onClick={reload}>重新读取</Button>
  return <section className="instance-administration__business-catalog" aria-label="业务流程列表">
    <div className="instance-administration__catalog-category">
      <button type="button" className="instance-administration__catalog-group-toggle" onClick={toggle} aria-expanded={expanded}><Icon iconKey="branches" /><strong>流程编排</strong></button>
      <Button type="text" size="small" icon={ADD} aria-label="新增流程" onClick={add} disabled={!model.data || model.pending} />
    </div>
    <div role="listbox" aria-label="编排流程" hidden={!expanded}>
      {model.flows.map((flow) => <FlowItem key={flow.workflow_id} id={flow.workflow_id} title={flow.title}
        active={model.data?.active_workflow_id === flow.workflow_id}
        selected={model.visible && model.selected?.workflow_id === flow.workflow_id} select={model.select} />)}
    </div>
    {model.error && !model.visible ? <Alert type="error" title={model.error} action={retry} role="alert" /> : null}
    {!model.flows.length && !model.loading && !model.error ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无业务流程">
      {model.data?.initial_workflow ? <Button onClick={initialize} loading={model.pending}>创建{model.data.initial_workflow.title}流程</Button> : null}
    </Empty> : null}
    <Modal title="新增流程" open={open} onCancel={close} onOk={submit} okText="创建草稿" cancelText="取消">
      <Form form={form} layout="vertical" onFinish={create} preserve={false}>
        <Form.Item name="title" label="流程名称" rules={RULES}><Input placeholder="请输入流程名称" maxLength={200} /></Form.Item>
      </Form>
    </Modal>
  </section>
}
